<template>
  <div class="asset-info">
    <van-cell>
      <template #title>
        <span class="title">{{ safeTitle }}</span>
        <span>{{ $t('assets.allconvert') }}($)</span>
      </template>
      <template #right-icon>
        <van-icon name="eye-o" size="20px" v-if="isopen" @click="changeOpen" style="margin-right: 30px;" />
        <van-icon name="closed-eye" size="20px" v-else  @click="changeOpen" style="margin-right: 30px;" />
      </template>
      <template #label>
        <p class="num">{{ isopen ? '$ '+safeNum:'****' }}</p>
        <span>&#8776; {{ isopen ? '$ '+safeNums:'****' }}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: 'AssetInfo',
  props: ['title', 'num', 'nums', 'isopen'],
  computed:{
    safeTitle(){
        return this.title || ''
    },
    safeNum(){
        return this.num || 0
    },
    safeNums(){
        return this.nums || 0
    },
    safeIsOpen(){
        return this.isopen || true
    }
  },
  watch:{
    isopen:{
        handler(newVal,oldVal){
            console.log(newVal+','+oldVal)
        },
        deep:true
    }
  },
  methods:{
    changeOpen(){
        this.$emit('child-event')
    }
  }
}
</script>

<style>

</style>
